/**
 * A text cell that a spreadsheet must show as text: a value starting with `=`, `+`, `-`, `@`, a tab or
 * a carriage return is prefixed with an apostrophe so it cannot run as a formula. Quoting follows
 * RFC 4180.
 */
export function csvTextCell(value: string): string {
  const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\r\n]/.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe;
}
